import type {
  JoowShell,
  MatchHandle,
  MatchMode,
  ModerationReportInput,
  ReportHistoryItem,
} from "./shell"

function currentLocale(): "fa-IR" | "en" {
  const locale = window.__JOOW_TEST_CONTEXT__?.locale
  if (locale === "fa") return "fa-IR"
  if (locale === "en") return "en"
  const languages = [navigator.language, ...(navigator.languages || [])].filter(Boolean)
  return languages.some((value) => value.toLowerCase().startsWith("fa")) ? "fa-IR" : "en"
}

function currentTheme(): "daylight" | "midnight" {
  const theme = window.__JOOW_TEST_CONTEXT__?.theme
  return theme === "dark" ? "midnight" : "daylight"
}

function mockHandle(): MatchHandle {
  return {
    onMatched() {
      return () => undefined
    },
    async next() {},
    async leave() {},
    onlineCount(callback) {
      callback(2314)
      return () => undefined
    },
  }
}

function emptyMediaSession(): Awaited<ReturnType<JoowShell["media"]["start"]>> {
  return {
    localStream: new MediaStream(),
    remoteStream: new MediaStream(),
    setMicEnabled() {},
    setCameraEnabled() {},
    onPeerAudioLevel(callback) {
      callback(0.64)
      return () => undefined
    },
    onState(callback) {
      callback("live")
      return () => undefined
    },
    stop() {},
  }
}

function storedReports(): ReportHistoryItem[] {
  const now = new Date().toISOString()
  return [
    { reportId: "mock-report-1", category: "harassment", createdAt: now, status: "reviewing" },
    { reportId: "mock-report-2", category: "scam", createdAt: now, status: "valid", outcome: "Action taken." },
    { reportId: "mock-report-3", category: "other", createdAt: now, status: "invalid", outcome: "Not enough evidence." },
  ]
}

export const mockShell: JoowShell = {
  version: "0.0.0-mock",
  identity: {
    async getPrincipal() {
      return { principalToken: "mock-principal", region: "IR", locale: currentLocale() }
    },
    async isAuthenticated() {
      return true
    },
    async requireAuth() {},
  },
  match: {
    async embedIntent(input) {
      const seed = input.text?.trim() || "joowfak"
      return { vector: Array.from(seed).slice(0, 8).map((char) => char.charCodeAt(0) / 1000), normalizedTopic: input.text || undefined }
    },
    async enqueue(_req: { vector: number[] | null; mode: MatchMode; topicLabel?: string }) {
      return mockHandle()
    },
  },
  media: {
    async start() {
      return emptyMediaSession()
    },
  },
  moderation: {
    async report(_report: ModerationReportInput) {
      return { reportId: `mock-report-${crypto.randomUUID()}`, status: "received" }
    },
    async myReports() {
      return storedReports()
    },
    async block() {},
  },
  surface: {
    theme: currentTheme,
    locale: currentLocale,
    setTitle(title) {
      document.title = title
    },
    onThemeChange() {
      return () => undefined
    },
    onLocaleChange() {
      return () => undefined
    },
    onForeground() {
      return () => undefined
    },
    haptics() {},
  },
}
